import React from 'react'

const getText = (line) => {
  return line.title
  // switch (line.variable) {
  //   case 'fenomeno':
  //   // case 'descripcionConducta':
  //   // case 'spoaCaracterizacion': return `${line.title} (Denuncias)`
  //   // case 'secadItem': return `${line.title} (Línea 123)`
  //   default: return line.title
  // }
}

const LineLegend = ({ line }) => {
  return (
    <div className='legend-container'>
      <div className='legend-circle' style={{ backgroundColor: line.color }}></div>
      {getText(line)}
    </div>
  )
}

export default LineLegend;
